export interface DynamicFlowStep {
  navigation: DynamicFlowNavigation;
  step?: DynamicFlowStepDetail;
  answer?: DynamicFlowAnswer;
  previousAnswers: DynamicFlowAnswer[];
  context?: DynamicFlowContext;
}

export interface DynamicFlowContext {
  externalId?: string;
}

export interface DynamicFlowNavigation {
  currentStep: number;
  estimatedSteps?: number;
  isFirstStep?: boolean;
  isLastStep?: boolean;
  submitOnLastStep?: boolean;
  canStartBooking?: boolean;
  buttons?: DynamicFlowNavigationButtons;
  nextFlow?: string;
  booking?: {
    type?: string;
  }
}

export interface DynamicFlowNavigationButtons {
  showNext: boolean;
  showPrevious: boolean;
  completeLabel: string;
}

export interface DynamicFlowContent {
  title?: string;
  description?: string;
}

export interface DynamicFlowLocation {
  title?: string;
  description?: string;
  defaultLocation?: {
    city: string;
    coordinates: {
      latitude: number;
      longitude: number;
    };
  }
  restrictions?: {
    countries: string[];
  };
}

export interface DynamicFlowStepDetail {
  id: string;
  type: DynamicFlowStepType;
  title: string;
  isOptional: boolean;
  question?: DynamicFlowQuestion;
  content?: DynamicFlowContent;
  location?: DynamicFlowLocation;
  form?: DynamicFlowForm;
}

export interface DynamicFlowForm {
  title: string;
  fields: DynamicFlowFormField[];
}

export interface DynamicFlowFormField {
  id: string;
  type: string;
  label: string;
  isRequired: boolean;
}

export interface DynamicFlowQuestion {
  title: string;
  description: string | null;
  options: DynamicFlowOption[] | null;
}

export interface DynamicFlowOption {
  id: string;
  value: string;
}

export interface DynamicFlowAnswer {
  stepId: string;
  selectedOptions?: DynamicFlowOption[];
  location?: DynamicFlowLocationAnswer;
  formValues?: DynamicFlowFormValue[];
}

export type DynamicFlowRawFormValues = Record<string, string>;

export interface DynamicFlowFormValue {
  fieldId: string;
  type: string;
  value: string;
}

export interface DynamicFlowLocationAnswer {
  city: string;
  distanceInKm: number;
  coordinates: {
    latitude: number;
    longitude: number;
  };
  country: string | null;
  countryCode: string | null;
  postalCode: string | null;
  street: string | null;
}

export enum DynamicFlowStepType {
  SINGLE_SELECT_QUESTION = 'singleSelectQuestion',
  MULTI_SELECT_QUESTION = 'multiSelectQuestion',
  LOCATION = 'location',
  CONTENT = 'content',
  BRANDED_CONTENT = 'brandedContent',
  FORM = 'form',
}

export const DYNAMIC_FLOW_INITIAL_STEP: DynamicFlowStep = {
  navigation: {
    currentStep: null,
  },
  answer: null,
  previousAnswers: [],
};